<template>
  <img
    v-if="isLazy"
    v-bind="$attrs"
    class="lazyload"
    :class="{ 'blur-up': blurUpEffect }"
    :src="lowSrc ?? undefined"
    :alt="alt ?? ''"
    :sizes="nativeSizes"
    :data-src="src"
    :data-srcset="srcset"
    :data-sizes="dataSizes"
  />
  <img v-else v-bind="$attrs" :src="src" :alt="alt ?? ''" :srcset="srcset" :sizes="nativeSizes" />
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    src: string
    alt?: string | null
    srcset?: string
    lowSrc?: string | null
    sizes?: string
    lazy?: boolean
  }>(),
  { sizes: 'auto', lazy: true },
)

const dataSizes = computed(() => {
  // `data-sizes` attribute only makes sense if value is "auto", otherwise
  // the native `sizes` attribute should be used
  return props.srcset && props.sizes === 'auto' ? props.sizes : undefined
})

const nativeSizes = computed(() => {
  return props.srcset && props.sizes !== 'auto' ? props.sizes : undefined
})

const isLazy = computed(() => {
  return props.lazy && !isChromatic
})

const blurUpEffect = computed(() => {
  return isLazy.value && props.lowSrc
})
</script>
